import React from 'react';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import FilterComponent from '../../components/FilterComponent';
import CounterFilterContainer from '@components/CounterFilter';

interface FilterLayoutProps {
  open: boolean;
  traitsData: CheckboxListData[];
  searchValue: string[];
  selectedItems: string[][];
  onChangeSearch: (event: string, index: number) => void;
  onChangeCheckbox: (event: string, index: number) => void;
  setCounterCount: (event: string, index: number) => void;
  onClose: () => void;
  onClickClearAll: () => void;
  onClickDone: () => void;
}

export interface CheckboxListData {
  id: number;
  label: string;
  type: string;
  value: {
    id: string;
    label: string;
    count: number;
  }[];
}

interface FilterContainerProps {
  data: CheckboxListData[];
  searchValue: string[];
  selectedItems: string[][];
  onChangeSearch: (event: string, index: number) => void;
  onChangeCheckbox: (event: string, index: number) => void;
  setCounterCount: (event: string, index: number) => void;
}

const FilterContainer = ({
  data,
  searchValue,
  selectedItems,
  onChangeCheckbox,
  setCounterCount,
  onChangeSearch,
}: FilterContainerProps) => {
  return (
    <>
      <Typography sx={{ fontSize: "14px", fontWeight: "700", color: "#242629", textTransform: 'uppercase' }}>Traits</Typography>
      { data?.map((item, index) => {
        const filterItem = item?.value?.filter(items =>
          (items?.label?.toLocaleLowerCase()?.includes(searchValue?.[index]?.toLocaleLowerCase()) || 
          (items?.label?.toLocaleLowerCase()?.includes('false') && searchValue?.[index]?.toLocaleLowerCase()?.startsWith('n') && "not claimed".includes(searchValue?.[index]?.toLocaleLowerCase())) ||
          (items?.label?.toLocaleLowerCase()?.includes('true') && searchValue?.[index]?.toLocaleLowerCase()?.startsWith('c') && "claimed".includes(searchValue?.[index]?.toLocaleLowerCase())) ));
        return (
          <>
            { (item?.type === 'Number') ? (
              <CounterFilterContainer
                count={ selectedItems?.[index]?.[0] ? parseInt(selectedItems[index][0]) : 0 }
                setCount={ (value) => setCounterCount(value, index) }
                title={ item?.label } />
            ) : (
              <FilterComponent
                index={ index }
                key={ item?.id }
                searchValue={ searchValue }
                onChangeSearch={ (event) => onChangeSearch(event.target.value, index) }
                items={ filterItem }
                selectedItems={ selectedItems?.[index] }
                titleCount={ filterItem?.length }
                title={ item?.label }
                onChangeCheckbox={ (event) => onChangeCheckbox(event, index) } />
            ) }
            <Divider sx={{ marginTop: '20px' }} />
          </>
        )
      }) }
    </>
  )
}

const FilterLayout = ({
  open,
  traitsData,
  searchValue,
  selectedItems,
  onChangeCheckbox,
  setCounterCount,
  onChangeSearch,
  onClose,
  onClickClearAll,
  onClickDone,
}: FilterLayoutProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <>
      {isMobile ? (
        <Dialog
          open={ open }
          onClose={ onClose }
          maxWidth="xl"
          fullWidth
          sx={{ margin: '0px', width: '100%', height: '100%', padding: '0px', maxHeight: '100%' }}
          PaperProps={{
            style: {
              boxShadow: 'none',
              margin: '0px', width: '100%', height: '100%', padding: '0px', maxHeight: '100%', maxWidth: '100%'
            },
          }}
        >
          <Box>
            <Box sx={{ padding: '16px', maxHeight: 'calc(100% - 56px)' }}>
              <Stack direction="row" sx={{ marginTop: '18px', marginBottom: '12px' }}>
                <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
                  <Typography sx={{ fontSize: '20px', color: '#242629', fontWeight: '700' }}>Filters</Typography>
                </Box>
                <IconButton onClick={ onClose }>
                  <CloseIcon sx={{ color: '#0000008F'}} />
                </IconButton>
              </Stack>
              <FilterContainer
                data={ traitsData }
                searchValue={ searchValue }
                selectedItems={ selectedItems }
                onChangeCheckbox={ onChangeCheckbox }
                setCounterCount={ setCounterCount }
                onChangeSearch={ onChangeSearch } />
              <Box sx={{ height: '80px' }} />
            </Box>
            <Stack direction="row" spacing={ 2 }
              sx={{ borderTop: '1px solid #BCBEC3', padding: '16px', position: 'fixed', bottom: 0, left: 0, width: '100%', background: '#fff' }}>
              <Button onClick={ onClickClearAll } sx={{ width: '100%', border: '1px solid #242629', color: '#242629' }}>Clear all</Button>
              <Button onClick={ onClickDone } sx={{ width: '100%', border: '1px solid #6563FD', color: '#6563FD' }}>Done</Button>
            </Stack>
          </Box>
        </Dialog>
      ) : (
        <Box sx={{ marginBottom: '55px' }}>
          <FilterContainer
            data={ traitsData }
            searchValue={ searchValue }
            selectedItems={ selectedItems }
            onChangeCheckbox={ onChangeCheckbox }
            setCounterCount={ setCounterCount }
            onChangeSearch={ onChangeSearch } />
        </Box>
      )}
    </>
  )
}

export default FilterLayout;